import { AiShoppableImageError } from "./AiShoppableImageError";

export class InsufficientCredits extends AiShoppableImageError {}